import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { preprocessEmptyStringAsNull } from '@dealstack/shared/lib/common/common.ts';
import { useEffect } from 'react';

export enum VESTING_TERMS_BULK_FORM_FIELD {
	vestingTermId = 'vestingTermId',
	startDate = 'startDate',
}

export const VestingTermsBulkShape = z.object({
	vestingTermId: z.string().nullable(),
	startDate: z.preprocess(preprocessEmptyStringAsNull, z.date().nullable()),
});
export type VestingTermsBulkFormDto = z.infer<typeof VestingTermsBulkShape>;

export const useVestingTermsBulkDrawerController = (defaultVestingTermId?: string | null) => {
	const vestingTermBulkForm = useForm<VestingTermsBulkFormDto>({
		mode: 'all',
		resolver: zodResolver(VestingTermsBulkShape),
		defaultValues: {
			vestingTermId: defaultVestingTermId ?? null,
			startDate: null,
		},
		shouldFocusError: false,
	});
	const formVestingTerm = vestingTermBulkForm.watch(VESTING_TERMS_BULK_FORM_FIELD.vestingTermId);

	useEffect(() => {
		vestingTermBulkForm.reset({
			vestingTermId: defaultVestingTermId ?? null,
			startDate: null,
		});
	}, [defaultVestingTermId]);

	useEffect(() => {
		if (!formVestingTerm) {
			vestingTermBulkForm.setValue(VESTING_TERMS_BULK_FORM_FIELD.startDate, null);
		}
	}, [formVestingTerm]);

	const resetForm = () => {
		vestingTermBulkForm.reset({
			vestingTermId: defaultVestingTermId ?? null,
			startDate: null,
		});
	};

	return {
		formVestingTerm,
		vestingTermBulkForm,
		resetForm,
	};
};
